import React from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { positions, Provider } from "react-alert"

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography';

import './prompt.css'


const useStyles = makeStyles({
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    pos: {
        marginBottom: 5,
        color: 'red',
        textAlign: 'center'
      }
})

const options = {
    timeout: 7500,
    position: positions.CENTER
  };

const BingoPrompt = () => {
    const classes = useStyles()
    const bull = <span className={classes.bullet}>•</span>
    const notify = () => toast(
        <Typography variant="h5" component="h2">
            B{bull}I{bull}N{bull}G{bull}O{bull}!
            <p>CONGRATULATIONS! Don't forget to send a screen shot to the OSRS Bingo Discord!</p>
        </Typography>
    )

    return (
        <div className='main'>
            <Provider template={options}>
                <button className='btn' onClick={notify}>
                    <Typography  className={classes.pos} variant="h5" component="h2">
                        B{bull}I{bull}N{bull}G{bull}O
                    </Typography>  
                    <Toaster />
                </button>
            </Provider>
        </div>
    )
}

export default BingoPrompt
